// src/components/Logout.jsx
import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { resetQueryCache } from '../../ui/data/queryClient';

const API = `${process.env.REACT_APP_API_BASEURL}/logout`;

// The one sign-out flow: tell the server, wipe local + session storage (token,
// authenticated, email, userId, onboarding flags), land on /sign-in. Exported
// so the redesign's user menu and phone More sheet run exactly this, rather
// than auth.logout() (which only drops `token`).
export async function logoutFlow(history) {
  try {
    await axios.post(`${API}?_method=DELETE`, {}, { withCredentials: true });
  } catch {
    // ignore
  } finally {
    try { localStorage.clear(); sessionStorage.clear(); } catch {}
    // One user's cached reads must never be shown to the next one.
    resetQueryCache();
    if (history) history.replace('/sign-in');
  }
}

class Logout extends Component {
  state = { loading: false };

  handleLogout = async (e) => {
    e.preventDefault();
    if (this.state.loading) return;
    this.setState({ loading: true });
    try {
      await logoutFlow(null);
    } finally {
      this.setState({ loading: false });
      this.props.history.replace('/sign-in');
    }
  };

  render() {
    return (
      <Button onClick={this.handleLogout} disabled={this.state.loading}>
        {this.state.loading ? 'Logging out…' : 'Logout'}
      </Button>
    );
  }
}

export default withRouter(Logout);
